<template>
  <v-card>
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>add</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Agent Details</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%" v-if="item">
      <!-- <div v-for="prop in agentProps">
      <strong>{{ prop.title }}</strong><br>
      <p>{{ item[prop.key] }}</p>
      </div> -->

      <v-layout row wrap>
        <v-flex md3>
          <strong>Name</strong><br />
          <p>{{ item.name }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Father's Name</strong><br />
          <p>{{ item.mother_name }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Mother's Name</strong><br />
          <p>{{ item.father_name }}</p>
        </v-flex>
      </v-layout>

      <u>Present Address:</u>
      <v-layout row wrap>
        <v-flex md3>
          <strong>District</strong><br />
          <p>{{ valueToText(districtTV(), item.present_district) }}</p>
        </v-flex>
        <v-flex md3>
          <strong>P.S</strong><br />
          <p>{{ valueToText(upazilaTV(), item.present_upazila) }}</p>
        </v-flex>
        <v-flex md3>
          <strong>P.O</strong><br />
          <p>{{ valueToText(unionTV(), item.present_union) }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Vill</strong><br />
          <p>{{ item.present_village }}</p>
        </v-flex>
      </v-layout>

      <u>Permanent Address:</u>
      <v-layout row wrap>
        <v-flex md3>
          <strong>District</strong><br />
          <p>{{ valueToText(districtTV(), item.permanent_district) }}</p>
        </v-flex>
        <v-flex md3>
          <strong>P.S</strong><br />
          <p>{{ valueToText(upazilaTV(), item.permanent_upazila) }}</p>
        </v-flex>
        <v-flex md3>
          <strong>P.O</strong><br />
          <p>{{ valueToText(unionTV(), item.permanent_union) }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Vill</strong><br />
          <p>{{ item.permanent_village }}</p>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md3>
          <strong>Date of Birth</strong><br />
          <p>{{ item.dob }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Age</strong><br />
          <p>{{ item.age }}</p>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md3>
          <strong>NID Number</strong><br />
          <p>{{ item.nid_number }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Nationality</strong><br />
          <p>{{ item.nationality }}</p>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md3>
          <strong>Gender</strong><br />
          <p>{{ item.gender }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Religion</strong><br />
          <p>{{ item.religion }}</p>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md3>
          <strong>Mobile Number</strong><br />
          <p>{{ item.mobile }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Emergency Contact</strong><br />
          <p>{{ item.emergency_contact }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Relation</strong><br />
          <p>{{ item.emergency_relation }}</p>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md3>
          <strong>Company Name</strong><br />
          <p>{{ item.company_name }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Staff Mobile No.</strong><br />
          <p>{{ item.company_staff_contact }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Email</strong><br />
          <p>{{ item.email }}</p>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md12>
          <strong>Notes</strong><br />
          <p>{{ item.notes }}</p>
        </v-flex>
      </v-layout>

      <MdsirFileWidget :ofID="item && item.id" ofName="agents" />

    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="onCancelled">Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { GENDERS } from "../../mdsir/const";
import { valueToText, getTV, districtTV, upazilaTV, unionTV } from "../../mdsir/MdsirUtils";
import MdsirFileWidget from "../file-widget/MdsirFileWidget";

export default {
  components: {
    MdsirFileWidget,
  },
  props: ["item"],
  data() {
    return {
      actionButtonClicked: false,
      valid: true,
      newItem: {
        name: "",
        mobile: "",
        email: "",
        notes: "",
        address: "",
      },
      // categories: []
      agentProps: [
        { title: "Name", key: "name" },
        { title: "Mobile", key: "mobile" },
        { title: "Email", key: "email" },
        { title: "Address", key: "address" },
        { title: "Notes", key: "notes" },
      ],
    };
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    },
    onNewItemAdded(addedData) {
      this.$emit("added", addedData);
      this.clearForm();
      this.onCancelled();
    },
    validate() {
      if (this.$refs.addAgentForm.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.addAgentForm.reset();
    },
    resetValidation() {
      this.$refs.addAgentForm.resetValidation();
    },
    clearForm() {
      this.newItem.name = "";
      this.newItem.mobile = "";
      this.newItem.email = "";
      this.newItem.address = "";
      this.newItem.notes = "";
    },
    newItemDo() {
      if (this.$refs.addAgentForm.validate()) {
        this.actionButtonClicked = true;
        this.post("/agent", this.newItem).then((res) => {
          if (res.data.success) {
            this.onNewItemAdded(res.data.data);
          }
          this.snackbarShow(res.data);
          this.actionButtonClicked = false;
        });
      }
    },
    districtTV: districtTV,
    upazilaTV: upazilaTV,
    unionTV: unionTV,
    getTV: getTV,
    valueToText: valueToText,
  },
  mounted() {},
  created() {
    this.GENDERS = GENDERS;
  },
};
</script>
